import React, { useEffect } from 'react';
import { Container, Row } from 'react-bootstrap';
import './StayInLoop.scss';
import { useNavigate } from 'react-router-dom';

const StayInLoop = () => {
    const navigate = useNavigate(); // Note: 'navigate' is conventionally lowercase

    useEffect(() => {
        // Load Klaviyo script dynamically
        const script = document.createElement('script');
        script.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=UHaSkS';
        script.type = 'text/javascript';
        script.async = true;
        document.body.appendChild(script);

        // Cleanup: Remove script when component unmounts
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div>
            <Container fluid className="about-container">
                <Row>
                    <div style={{paddingTop: 100, paddingBottom: 100}}>
                        <div className="klaviyo-form-SLpgMK"></div>
                    </div>
                </Row>
            </Container>
        </div>
    );
};

export default StayInLoop;